import { gql } from 'urql';

export const UserBasicInfo = gql`
  fragment UserBasicInfo on User {
    id
    fullName
    firstName
    lastName
    preferredName
    emailAddress
    userOrganization {
      id
      role
      assistantFlags
      branch {
        id
        name
        shorthand
      }
    }
  }
`;
